<script>
import { useAlert } from 'dashboard/composables';

export default {
  props: {
    message: {
      type: Object,
      default: () => {},
      required: true,
    },
    inboxId: {
      type: Number,
      required: true,
    },
    messageOrder: {
      type: Number,
      required: true,
    },
    timeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      unassignConversation: false,
      messageContent: '',
      messageTime: 0,
      isLoading: false,
    };
  },
  computed: {
    pageTitle() {
      return (
        this.$t('INBOX_MGMT.TEIMOSINHA.EDIT_ACTION.HEADER') +
        ' ' +
        this.messageOrder
      );
    },
  },
  mounted() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.messageContent = this.message.content;
      this.messageTime = this.message.time_to_send_seconds;
      this.unassignConversation = this.message.unassign_conversation || false;
    },
    async editTeimosinhaAction() {
      const payload = {
        inboxId: this.inboxId,
        messageId: this.message.id,
        teimosinhaSettings: {
          content: this.messageContent,
          time_to_send_seconds: this.messageTime,
          unassign_conversation: this.unassignConversation,
          teimosinha_type: 1, // Tipo 1 para ações de agentes
        },
      };
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          'inboxes/updateTeimosinhaMessageSettings',
          payload
        );
        this.isLoading = false;
        this.onClose();
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.API.ERROR_MESSAGE')
        );
        this.isLoading = false;
      }
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col">
    <woot-modal-header :header-title="pageTitle" />
    <form class="mx-0 flex flex-wrap" @submit.prevent="editTeimosinhaAction">
      <!-- TIME WITHOUT RESPONSE -->
      <div class="w-full mb-4">
        <label class="block text-sm font-medium text-slate-700 mb-1">
          {{
            $t(
              'INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.HEADER'
            )
          }}
        </label>
        <span class="text-xs text-slate-500 mb-2 block">
          {{
            $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.INFO')
          }}
        </span>
        <select
          v-model="messageTime"
          class="w-full p-2 border border-slate-300 rounded-md"
        >
          <option
            v-for="time in timeOptions"
            :key="time.key"
            :value="time.key"
            :disabled="time.disabled"
          >
            {{ time.name }}
          </option>
        </select>
      </div>

      <!-- UNASSIGN CONVERSATION -->
      <div class="w-full mb-4">
        <label class="block text-sm font-medium text-slate-700 mb-1">
          {{
            $t('INBOX_MGMT.TEIMOSINHA.EDIT_ACTION.UNASSIGN_CONVERSATION.HEADER')
          }}
        </label>
        <span class="text-xs text-slate-500 mb-2 block">
          {{
            $t('INBOX_MGMT.TEIMOSINHA.EDIT_ACTION.UNASSIGN_CONVERSATION.INFO')
          }}
        </span>
        <div class="flex items-center">
          <input
            id="unassignConversation"
            v-model="unassignConversation"
            type="checkbox"
            class="h-4 w-4 text-woot-600 focus:ring-woot-500 border-slate-300 rounded"
          />
          <label
            for="unassignConversation"
            class="ml-2 block text-sm text-slate-700"
          >
            {{
              $t(
                'INBOX_MGMT.TEIMOSINHA.EDIT_ACTION.UNASSIGN_CONVERSATION.LABEL'
              )
            }}
          </label>
        </div>
      </div>

      <!-- MESSAGE CONTENT -->
      <woot-input
        v-model.trim="messageContent"
        v-tooltip.bottom="messageContent"
        class="w-full mb-4"
        :label="$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.HEADER')"
        :placeholder="
          $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.PLACE_HOLDER')
        "
      />

      <div class="flex justify-end items-center py-2 px-0 gap-2 w-full">
        <woot-button :is-loading="isLoading">
          {{ $t('LABEL_MGMT.FORM.EDIT') }}
        </woot-button>
        <woot-button
          :is-loading="isLoading"
          class="button clear"
          @click.prevent="onClose"
        >
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<style scoped>
select {
  @apply w-full p-2 border border-slate-300 rounded-md;
}
</style>
